import { getBaseEntite } from "../../../utilities/defaultObjects"
import {
	ENTITE_TYPE_PERSONNE_PHYSIQUE,
	ENTITE_TYPE_SOCIETE,
} from "../entite/Entite"

// Création d'un client : base, validation et envoi PARTAGÉS par la fiche
// client (/clients/nouveau, ClientFicheV2) et la création rapide du modal
// « Associer un client » de la fiche atelier (GE-67) — un seul formulaire de
// règles à maintenir, même endpoint (POST api/entites).

export const CLIENT_TYPES = [ENTITE_TYPE_SOCIETE, ENTITE_TYPE_PERSONNE_PHYSIQUE]

export const nouveauClient = (type) => {
	const base = getBaseEntite()
	base.type = CLIENT_TYPES.includes(type) ? type : ENTITE_TYPE_SOCIETE
	base.vehicules = [] // ajout des véhicules après le 1er enregistrement
	return base
}

// Société : raison sociale + téléphone ; personne : nom, prénom, téléphone.
export const clientInvalide = (entite) =>
	entite.type === ENTITE_TYPE_SOCIETE
		? !(entite.label || "").trim() || !(entite.telephone || "").trim()
		: !(entite.nom || "").trim() ||
			!(entite.prenom || "").trim() ||
			!(entite.telephone || "").trim()

export const clientVersFormData = (entite) => {
	const fd = new FormData()
	for (let [k, v] of Object.entries(entite)) {
		// La flotte du client est préservée côté serveur (EntiteView ne
		// touche pas aux véhicules non envoyés).
		if (k === "vehicules") continue
		else if (
			["adresses", "personnes", "fournitures", "extra_data"].includes(k)
		)
			fd.append(k, JSON.stringify(v))
		else fd.append(k, v)
	}
	return fd
}
